import axios from '@/server/request'
import { isEmpty } from '@/utils/common'

const state = {
    // 资讯来源数据
    sourceOptions: [],
    // 发文渠道搜索数据
    channelOptions: {},
    // 企业筛选搜索数据
    companyOptions: {},
    // 全局搜索数据
    globalSearchOptions: {},
    // 文章搜索结果
    articleData: {},
    // 账号搜索结果
    accountData: {},
    // 推荐公众号搜索结果
    recommendAccountData: [],
    // 政府要元数据
    leaderData: {},
    isGlobalSearchLoading: false,
    isChannelLoading: false,
    isCompanyLoading: false,
    isAccountLoading: false,
    isArticleLoading: false,
    isRecommendAccountLoading: false,
    isLeaderLoading: false,
    // 舆情文章列表
    opinionDataList: [],
    // 文章加载状态
    opinionDataLoading: false,
    // 舆情资讯来源数据
    opinionSourceOptions: [],

    // 项目详情文章列表
    projectArticleData: [],
    // 文章加载状态
    projectDataLoading: false,
    // 项目详情资讯来源数据
    projectSourceOptions: []
}

const getters = {
    weixinChannelOptions: state => state.channelOptions.weixin,
    toutiaoChannelOptions: state => state.channelOptions.toutiao,
    websiteChannelOptions: state => state.channelOptions.website,
    articleOptions: state => state.globalSearchOptions.article,
    accountOptions: state => state.globalSearchOptions.account,
    historyOptions: state => state.globalSearchOptions.history,
    companyOptions: state => state.companyOptions
}

const mutations = {
    updateSource(state, payload) {
        state.sourceOptions.splice(0)
        state.sourceOptions = payload
    },

    updateChannel(state, payload) {
        state.channelOptions = null
        state.channelOptions = payload
    },

    updateCompany(state, payload) {
        state.companyOptions = null
        state.companyOptions = payload
    },

    updateChannelLoading(state, payload) {
        state.isChannelLoading = payload
    },

    updateGlobalSearch(state, payload) {
        state.globalSearchOptions = null
        state.globalSearchOptions = payload
    },

    updateGlobalSearchLoading(state, payload) {
        state.isGlobalSearchLoading = payload
    },

    updateArticle(state, payload) {
        state.articleData = null
        state.articleData = payload
    },

    updateArticleLoading(state, payload) {
        state.isArticleLoading = payload
    },

    updateAccount(state, payload) {
        state.accountData = null
        state.accountData = payload
    },

    updateAccountLoading(state, payload) {
        state.isAccountLoading = payload
    },

    updateRecommendAccount(state, payload) {
        state.recommendAccountData.splice(0)
        state.recommendAccountData = payload
    },

    updateRecommendAccountLoading(state, payload) {
        state.isRecommendAccountLoading = payload
    },

    updateLeader(state, payload) {
        state.leaderData = null
        state.leaderData = payload
    },

    updateLeaderLoading(state, payload) {
        state.isLeaderLoading = payload
    },

    updateCompanyLoading(state, payload) {
        state.isCompanyLoading = payload
    },
    updateOpinionDataList(state, payload) {
        state.opinionDataList = payload
    },

    updateOpinionDataLoading(state, payload) {
        state.opinionDataLoading = payload
    },

    updateOpinionSource(state, payload) {
        state.opinionSourceOptions = payload
    },
    updateProjectArticleList(state, payload) {
        state.projectArticleData = payload
    },

    updateProjectDataLoading(state, payload) {
        state.projectDataLoading = payload
    },

    updateProjectSource(state, payload) {
        state.projectSourceOptions = payload
    }
}

const actions = {
    // 项目详情相关
    async fetchProjectCount({ commit }, params) {
        try {
            const res = await axios.get({
                url: '/Projectsearch/articleCount',
                params
            })

            if (res.data.ErrorCode === 200) {
                const options = res.data.Data.map(item => {
                    if (item.value === 999) {
                        item.field = ['wechat', 'toutiao', 'zixun']
                    } else if (item.value === 1) {
                        item.field = 'wechat'
                    } else if (item.value === 3) {
                        item.field = 'toutiao'
                    } else if (item.value === 4) {
                        item.field = 'zhengce'
                    } else if (item.value === 5) {
                        item.field = 'zixun'
                    }
                    return item
                })
                commit('updateProjectSource', options)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    async fetchProjectDataList({ commit }, params) {
        commit('updateProjectDataLoading', true)
        try {
            const res = await axios.post({
                url: '/Projectsearch/article',
                params
            })
            if (res.data.ErrorCode === 200) {
                commit('updateProjectArticleList', res.data.Data)
                commit('updateProjectDataLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateProjectDataLoading', false)
        }
    },

    // 获取舆情文章统计数量
    async fetchOpinionCount({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/Fangqisearch/articleCount',
                params
            })

            if (res.data.ErrorCode === 200) {
                const options = res.data.Data.map(item => {
                    if (item.value === 999) {
                        item.field = ['wechat', 'toutiao', 'zixun']
                    } else if (item.value === 1) {
                        item.field = 'wechat'
                    } else if (item.value === 3) {
                        item.field = 'toutiao'
                    } else if (item.value === 4) {
                        item.field = 'zhengce'
                    } else if (item.value === 5) {
                        item.field = 'zixun'
                    }
                    return item
                })
                commit('updateOpinionSource', options)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 舆情文章列表
    async fetchOpinionDataList({ commit }, params ) {
        commit('updateOpinionDataLoading', true)
        try {
            const res = await axios.post({
                url: '/Fangqisearch/article',
                params
            })
            if (res.data.ErrorCode === 200) {
                console.log('666666666666', res.data.Data)
                commit('updateOpinionDataList', res.data.Data)
                commit('updateOpinionDataLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateOpinionDataLoading', false)
        }
    },
    // 企业筛选列表
    async fetchCompany({ commit }, params ) {
        commit('updateCompanyLoading', true)
        try {
            const res = await axios.get({
                url: '/Fangqisearch/searchFangqi',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateCompany', res.data.Data)
                commit('updateCompanyLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateCompanyLoading', false)
        }
    },
    // 搜索联想
    async fetchRelationWord({ commit }, params) {
        commit('updateGlobalSearchLoading', true)
        try {
            const res = await axios.get({
                url: '/search/getRelationWord',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateGlobalSearch', res.data.Data)
                commit('updateGlobalSearchLoading', false)
                return Promise.resolve(!isEmpty(res.data.Data.history) && res.data.Data.history.options.length)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateGlobalSearchLoading', false)
        }
    },

    // 发文渠道搜索联想
    async fetchChannel({ commit }, params) {
        commit('updateChannelLoading', true)
        try {
            const res = await axios.get({
                url: '/search/customChannel',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateChannel', res.data.Data)
                commit('updateChannelLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateChannelLoading', false)
        }
    },

    // 获取文章统计数量
    async fetchArticleCount({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/search/articleCount',
                params
            })

            if (res.data.ErrorCode === 200) {
                const options = res.data.Data.map(item => {
                    if (item.value === 999) {
                        item.field = ['wechat', 'toutiao', 'zhengce', 'zixun']
                    } else if (item.value === 1) {
                        item.field = 'wechat'
                    } else if (item.value === 3) {
                        item.field = 'toutiao'
                    } else if (item.value === 4) {
                        item.field = 'zhengce'
                    } else if (item.value === 5) {
                        item.field = 'zixun'
                    }
                    return item
                })
                commit('updateSource', options)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 文章搜索
    async fetchArticle({ commit, dispatch }, params) {
        commit('updateArticleLoading', true)
        // 用于区分分页变化请求
        let isOnce = false
        if (params.once) {
            isOnce = true
            delete params.once
        }

        try {
            const res = await axios.post({
                url: '/search/article',
                params
            })

            !isOnce && dispatch('pushLog', Object.assign(params, { sSearchType: 'article' }))

            if (res.data.ErrorCode === 200) {
                commit('updateArticle', res.data.Data)
                commit('updateArticleLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateArticleLoading', false)
        }
    },

    // 账号搜索
    async fetchAccount({ commit, dispatch }, params) {
        commit('updateAccountLoading', true)
        // 用于区分分页变化请求
        let isOnce = false
        if (params.once) {
            isOnce = true
            delete params.once
        }
        try {
            const res = await axios.post({
                url: '/search/account',
                params
            })
            !isOnce && dispatch('pushLog', Object.assign(params, { sSearchType: 'account' }))

            if (res.data.ErrorCode === 200) {
                commit('updateAccount', res.data.Data)
                commit('updateAccountLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateAccountLoading', false)
        }
    },

    // 搜索记录Log, 每次点击完【搜索】向后端发送一次
    async pushLog(context, params) {
        try {
            await axios.post({
                url: '/search/SearchLog',
                params
            })
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 搜索右侧账号推荐
    async fetchRecommendAccount({ commit }, params) {
        commit('updateRecommendAccountLoading', true)
        try {
            const res = await axios.post({
                url: '/search/accountRecommend',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateRecommendAccount', res.data.Data)
                commit('updateRecommendAccountLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateRecommendAccountLoading', false)
        }
    },

    // 搜文章 右侧信息(微信账号和领导人)
    async fetchAccountAndLeader({ commit }, params) {
        commit('updateLeaderLoading', true)
        try {
            const res = await axios.post({
                url: '/search/rightInfo',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateLeader', res.data.Data)
                commit('updateLeaderLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateLeaderLoading', false)
        }
    },

    // 添加公众号订阅
    async addAccount(context, params) {
        try {
            const res = await axios.post({
                url: '/customizesubscribe/add',
                params
            })

            if (res.data.ErrorCode === 200) {
                return Promise.resolve()
            } else {
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            return Promise.reject(errMsg)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
